import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class SpecificGravityService {
    constructor(http) {
        this.http = http;
        this.singular = 'specific gravity';
        this.plural = 'specific gravities';
        this.editor = PLATFORM.moduleName('pages/system-fields/specific-gravities/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`specific-gravities/filter/${loadOptions}`);
        return await response.json();
    }

    async create(specificGravity) {
        await this.http.fetch('specific-gravities', { method: 'POST', body: json(specificGravity) });
    }

    async update(specificGravity) {
        await this.http.fetch(`specific-gravities/${specificGravity.id}`, { method: 'PUT', body: json(specificGravity) });
    }

    async delete(id) {
        await this.http.fetch(`specific-gravities/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`specific-gravities/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`specific-gravities/top-three/${query}`);
        return await response.json();
    }
}